import React from "react";
import { Col } from "react-bootstrap";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const CountryFrom = () => {
    const { addBreadcrumb } = useBreadcrumbs();
    return (
        <AnimateWrapper>
            <BasicQuestion
                question="Vanaf welk land wilt u het pakket versturen?"
                answers={
                    <>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                body={"Nederland"}
                                onClick={() => {
                                    addBreadcrumb(
                                        {
                                            href: "/to",
                                            text: "Land naar"
                                        },
                                        {
                                            countryFrom: "NL"
                                        },
                                        [
                                            {
                                                href: "/",
                                                text: "Nederland",
                                                disabled: true
                                            }
                                        ]
                                    );
                                }}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                body={"België"}
                                onClick={() => {
                                    addBreadcrumb(
                                        {
                                            href: "/to",
                                            text: "Land naar"
                                        },
                                        {
                                            countryFrom: "BE"
                                        },
                                        [
                                            {
                                                href: "/",
                                                text: "België",
                                                disabled: true
                                            }
                                        ]
                                    );
                                }}
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper>
    );
};

export default CountryFrom;
